tinymce.PluginManager.add('indent2em', function (editor, url) {
    var pluginName = '首行缩进';
    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');
    var indent2em_val = editor.getParam('indent2em_val', '2em');
    var doAct = function () {
        var dom = editor.dom;
        var blocks = editor.selection.getSelectedBlocks();
        var act = '';
        global$1.each(blocks, function (block) {
            if (block.childNodes.length == 1 && block.childNodes[0].nodeName == "IMG") {

            } else {
                if (act == '') {
                    act = dom.getStyle(block, 'text-indent') == indent2em_val ? 'remove' : 'add';
                }
                if (act == 'add') {
                    dom.setStyle(block, 'text-indent', indent2em_val);
                } else {
                    var style = dom.getAttrib(block, 'style');
                    var reg = new RegExp('text-indent:[\\s]*' + indent2em_val + ';', 'ig');
                    style = style.replace(reg, '');
                    dom.setAttrib(block, 'style', style);
                }
            }
        });
    };

    editor.ui.registry.getAll().icons.indent2em || editor.ui.registry.addIcon('indent2em', '<svg width="28" height="28" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="design-iconfont"><mask id="szj8zifur__spem22bbma" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><path fill="#D9D9D9" d="M0 0H24V24H0z"/></mask><g mask="url(#szj8zifur__spem22bbma)" stroke="#333" stroke-width="1.5" stroke-linecap="round"><path d="M4.5 14.25H13.5"/><path d="M4.5 18H19.5"/><path d="M4.5 6H19.5"/><path d="M4.5 9.75H13.5"/><path d="M16.5 9.75L19.5 12L16.5 14.25" stroke-linejoin="round"/></g></svg>');

    var stateSelectorAdapter = function (editor, selector) {
        return function (buttonApi) {
            return editor.selection.selectorChangedWithUnbind(selector.join(','), buttonApi.setActive).unbind;
        };
    };

    editor.ui.registry.addToggleButton('indent2em', {
        icon: 'indent2em',
        tooltip: pluginName,
        onAction: function () {
            doAct();
        },
        onSetup: stateSelectorAdapter(editor, [
            '*[style*="text-indent"]',
            '*[data-mce-style*="text-indent"]',
        ])
    });

    editor.ui.registry.addMenuItem('indent2em', {
        text: pluginName,
        onAction: function () {
            doAct();
        }
    });

    editor.addCommand('indent2em', doAct);

    return {
        getMetadata: function () {
            return {
                name: pluginName,
                url: "http://tinymce.ax-z.cn/more-plugins/indent2em.php",
            };
        }
    };
});
